const searchFieldRegex = input => {
    const globalRegex = new RegExp(/^[A-Za-z0-9.,?@&;:!+#'~*/ _-]*$/, 'g');

    return globalRegex.test(input);
}

export default searchFieldRegex;